import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const METRICS = [
  { label: "STATES COVERED", value: "50" },
  { label: "SHIPMENT MODES", value: "FTL + LTL" },
  { label: "OPERATING REACH", value: "REGIONAL + OTR" },
];

export default function Network() {
  return (
    <section id="network" className="relative py-20 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-5"
        >
          <div className="max-w-3xl">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#F59E0B]">
              03 // NETWORK
            </p>
            <h2 className="mt-3 font-display text-2xl font-black uppercase tracking-tight text-white sm:text-3xl lg:text-4xl">
              Nationwide Coordination
            </h2>
            <p
              data-testid="network-description"
              className="mt-4 max-w-2xl text-base leading-7 text-slate-300 lg:text-[17px] lg:leading-8"
            >
              Southern California is home, but our work is not limited to local freight. We are equally experienced and comfortable coordinating regional, long-haul, and multi-state shipments across the United States, with direct communication and equipment-focused planning throughout the process.
            </p>
          </div>
          <div className="flex items-center gap-3 border border-[#222736] bg-[#12141C] px-4 py-2">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#10B981] opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#10B981]" />
            </span>
            <span className="font-mono text-[10px] font-semibold tracking-[0.2em] text-slate-400">
              SHIPPER + CARRIER COVERAGE
            </span>
          </div>
        </motion.div>

        <motion.div
          data-testid="network-metrics-grid"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mt-10 grid grid-cols-1 gap-px border border-[#222736] bg-[#222736] sm:grid-cols-3"
        >
          {METRICS.map((m, i) => (
            <div
              key={m.label}
              data-testid={`network-metric-${i + 1}`}
              className="group bg-[#0A0B0E] p-6 transition-colors duration-500 hover:bg-[#12141C] md:p-7"
            >
              <span className="break-words font-mono text-2xl font-extrabold text-white sm:text-3xl lg:text-4xl">
                {m.value}
              </span>
              <div className="mt-4 h-px w-10 bg-[#FF5500] transition-[width] duration-500 group-hover:w-full" />
              <p className="mt-3 font-mono text-[10px] font-semibold tracking-[0.25em] text-slate-500">
                {m.label}
              </p>
            </div>
          ))}
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="mt-5 font-mono text-[10px] tracking-[0.2em] text-slate-600"
        >
          SERVICE AVAILABILITY DEPENDS ON SHIPMENT DETAILS, EQUIPMENT, LANE, AND TIMING.
        </motion.p>
      </div>
    </section>
  );
}
